module.exports = __webpack_public_path__ + "media/lots.097200c7.jpg";